import { create } from "zustand";

interface FilePreviewState {
  path: string | null;
  content: string | null;
  language: string | null;
  loading: boolean;
  open: (path: string) => void;
  close: () => void;
}

function langFromPath(p: string): string {
  const ext = p.split(".").pop()?.toLowerCase() || "";
  const map: Record<string, string> = {
    py: "python", js: "javascript", ts: "typescript", tsx: "tsx", jsx: "jsx",
    html: "html", css: "css", json: "json", md: "markdown", yml: "yaml",
    yaml: "yaml", sh: "bash", sql: "sql", rs: "rust", go: "go", rb: "ruby",
    txt: "text",
  };
  return map[ext] || "text";
}

export const useFilePreview = create<FilePreviewState>((set) => ({
  path: null,
  content: null,
  language: null,
  loading: false,
  open: async (path) => {
    set({ path, content: null, language: langFromPath(path), loading: true });
    try {
      const { getBaseUrl } = await import("./storage");
      const { getToken } = await import("./storage");
      const r = await fetch(
        `${getBaseUrl()}/api/v1/aicores-ui/workspace/file?path=${encodeURIComponent(path)}`,
        { headers: { Authorization: `Bearer ${getToken()}` } },
      );
      if (!r.ok) throw new Error(`${r.status}`);
      const data = await r.json();
      set({ content: data.content || data.text || "", loading: false });
    } catch {
      set({ content: "// Не удалось загрузить файл", loading: false });
    }
  },
  close: () => set({ path: null, content: null, loading: false }),
}));
